const loading_datatable = (payload) => {
  return {
    type: "table_loading",
    payload,
  };
};

export default loading_datatable;
